(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.stormlight-contact-section[data-section-id]');
    if (!section) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = section.querySelectorAll('.reveal');

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function(el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function(el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.stormlight-faq-section[data-section-id]');
    if (!section) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = section.querySelectorAll('.reveal');

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function(el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function(el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.stormlight-story-section[data-section-id]');
    if (!section) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = section.querySelectorAll('.reveal');

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function(el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function(el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-1200"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;
  sections.forEach(function(section) {
    

    /* === Hero — random slide on page load ===
       Picks one of the populated slides at random when the page loads.
       No rotation, no carousel, no extra fetches. Slide 1 is eager-
       loaded so the page renders fast even when the random pick lands
       on it; slides 2 and 3 are lazy and only download if picked. */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var credits = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          credits.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

/* Reveal on scroll */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }
    /* Gallery thumb switching */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullUrl = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl) {
            mainImg.src = fullUrl;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
    /* AJAX add to cart */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;
        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }
        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-700"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;
  sections.forEach(function(section) {
    

    /* === Hero — random slide on page load ===
       Picks one of the populated slides at random when the page loads.
       No rotation, no carousel, no extra fetches. Slide 1 is eager-
       loaded so the page renders fast even when the random pick lands
       on it; slides 2 and 3 are lazy and only download if picked. */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var credits = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          credits.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

/* Reveal on scroll */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }
    /* Gallery thumb switching */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullUrl = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl) {
            mainImg.src = fullUrl;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
    /* AJAX add to cart */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;
        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }
        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('products-loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repair-service"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.stormlight-repair-section[data-section-id]');
    if (!section) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = section.querySelectorAll('.reveal');

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function(el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function(el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-returns"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.stormlight-shipping-section[data-section-id]');
    if (!section) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = section.querySelectorAll('.reveal');

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function(el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function(el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spare-part"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-spare-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* Reveal on scroll */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* AJAX add to cart */
    var forms = section.querySelectorAll('[data-sl-spare-cart]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-spare-cta');
        var feedback = form.querySelector('[data-sl-spare-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function() {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-1200"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* === Hero — random slide on page load === */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var credits = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          credits.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

    /* === Reveal on scroll === */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* === Gallery thumbnails === */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          var fullUrl = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl && mainImg) {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = fullUrl;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* === Cart forms === */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

    /* === Sticky mobile CTA visibility === */
    var stickyCta = section.querySelector('[data-sl-sticky-cta]');
    var buyBlock = section.querySelector('.sl-buy-block');
    var bottomCta = section.querySelector('.sl-bottom-cta');

    if (stickyCta && buyBlock && bottomCta && 'IntersectionObserver' in window) {
      var state = { buyPassed: false, bottomVisible: false };

      function applyState() {
        if (state.buyPassed && !state.bottomVisible) {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      }

      var buyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            state.buyPassed = true;
          } else if (entry.isIntersecting) {
            state.buyPassed = false;
          }
          applyState();
        });
      }, { threshold: 0 });
      buyObs.observe(buyBlock);

      var bottomObs = new IntersectionObserver(function(entries) {
        state.bottomVisible = entries[0].isIntersecting;
        applyState();
      }, { threshold: 0.05 });
      bottomObs.observe(bottomCta);
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-3100"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* === Hero — random slide on page load ===
       Picks one of the populated slides at random when the page loads.
       No rotation, no carousel, no extra fetches. Slide 1 is eager-
       loaded so the page renders fast even when the random pick lands
       on it; slides 2 and 3 are lazy and only download if picked. */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var captions = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          captions.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

    /* === Reveal on scroll === */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* === Gallery thumbnails === */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullUrl = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl) {
            mainImg.src = fullUrl;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* === Cart forms (main, bottom, sticky — single handler) === */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

    /* === FAQ accordion ===
       The FAQ click handler lives in an inline script tag at the end
       of the section markup (just before the closing section tag)
       instead of here. Shopify's static JS block wraps content in a
       section-registry check that can fail silently in some themes
       (Taiga among them), leaving handlers unattached. */

    /* === Sticky mobile CTA visibility === */
    var stickyCta = section.querySelector('[data-sl-sticky-cta]');
    var buyBlock = section.querySelector('.sl-buy-block');
    var bottomCta = section.querySelector('.sl-bottom-cta');

    if (stickyCta && buyBlock && bottomCta && 'IntersectionObserver' in window) {
      var state = { buyPassed: false, bottomVisible: false };

      function applyState() {
        if (state.buyPassed && !state.bottomVisible) {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      }

      var buyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            state.buyPassed = true;
          } else if (entry.isIntersecting) {
            state.buyPassed = false;
          }
          applyState();
        });
      }, { threshold: 0 });
      buyObs.observe(buyBlock);

      var bottomObs = new IntersectionObserver(function(entries) {
        state.bottomVisible = entries[0].isIntersecting;
        applyState();
      }, { threshold: 0.05 });
      bottomObs.observe(bottomCta);
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-700"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* === Hero — random slide on page load ===
       Picks one of the populated slides at random when the page loads.
       No rotation, no carousel, no extra fetches. Slide 1 is eager-
       loaded so the page renders fast even when the random pick lands
       on it; slides 2 and 3 are lazy and only download if picked. */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var credits = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          credits.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

    /* === Reveal on scroll === */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* === Gallery thumbnails ===
       Defensive swap: removes any srcset/sizes from main image before
       setting new src. This prevents browser from using a stale srcset
       that overrides the src update. */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          var fullUrl = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl && mainImg) {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = fullUrl;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* === Cart forms (main, bottom, sticky — single handler) === */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

    /* === Sticky mobile CTA visibility ===
       Visible when:
         - the buy block is fully scrolled past (above viewport), AND
         - the bottom CTA is not currently in view.
       Uses two IntersectionObservers feeding a shared state. */
    var stickyCta = section.querySelector('[data-sl-sticky-cta]');
    var buyBlock = section.querySelector('.sl-buy-block');
    var bottomCta = section.querySelector('.sl-bottom-cta');

    if (stickyCta && buyBlock && bottomCta && 'IntersectionObserver' in window) {
      var state = { buyPassed: false, bottomVisible: false };

      function applyState() {
        if (state.buyPassed && !state.bottomVisible) {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      }

      var buyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            state.buyPassed = true;
          } else if (entry.isIntersecting) {
            state.buyPassed = false;
          }
          applyState();
        });
      }, { threshold: 0 });
      buyObs.observe(buyBlock);

      var bottomObs = new IntersectionObserver(function(entries) {
        state.bottomVisible = entries[0].isIntersecting;
        applyState();
      }, { threshold: 0.05 });
      bottomObs.observe(bottomCta);
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-9000"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* === Hero — random slide on page load ===
       Picks one of the populated slides at random when the page loads.
       No rotation, no carousel, no extra fetches. Slide 1 is eager-
       loaded so the page renders fast even when the random pick lands
       on it; slides 2 and 3 are lazy and only download if picked. */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var credits = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          credits.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

    /* === Reveal on scroll === */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* === Gallery thumbnails === */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullUrl = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl) {
            mainImg.src = fullUrl;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* === Cart forms (main, bottom, sticky — single handler) === */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

    /* === FAQ accordion ===
       Note: the FAQ click handler lives in an inline script tag at the
       end of the section markup (just before the closing section tag)
       instead of here. Shopify's static JS block wraps content in a
       section-registry check that can fail silently in some themes
       (Taiga among them), leaving handlers unattached. The inline
       script runs immediately as parsed and bypasses that wrapper. */

    /* === Sticky mobile CTA visibility ===
       Visible when:
         - the buy block is fully scrolled past (above viewport), AND
         - the bottom CTA is not currently in view.
       Uses two IntersectionObservers feeding a shared state. */
    var stickyCta = section.querySelector('[data-sl-sticky-cta]');
    var buyBlock = section.querySelector('.sl-buy-block');
    var bottomCta = section.querySelector('.sl-bottom-cta');

    if (stickyCta && buyBlock && bottomCta && 'IntersectionObserver' in window) {
      var state = { buyPassed: false, bottomVisible: false };

      function applyState() {
        if (state.buyPassed && !state.bottomVisible) {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      }

      var buyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          /* "Passed" = buy block has fully scrolled above viewport */
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            state.buyPassed = true;
          } else if (entry.isIntersecting) {
            state.buyPassed = false;
          }
          applyState();
        });
      }, { threshold: 0 });
      buyObs.observe(buyBlock);

      var bottomObs = new IntersectionObserver(function(entries) {
        state.bottomVisible = entries[0].isIntersecting;
        applyState();
      }, { threshold: 0.05 });
      bottomObs.observe(bottomCta);
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storm-3100"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* === Hero — random slide on page load === */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var captions = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          captions.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

    /* === Reveal on scroll === */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* === Gallery thumbnails === */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullUrl = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl) {
            mainImg.src = fullUrl;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* === Cart forms (main, bottom, sticky — single handler) === */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

    /* === FAQ accordion ===
       Handled by the inline script at the end of the section markup. */

    /* === Sticky mobile CTA visibility === */
    var stickyCta = section.querySelector('[data-sl-sticky-cta]');
    var buyBlock = section.querySelector('.sl-buy-block');
    var bottomCta = section.querySelector('.sl-bottom-cta');

    if (stickyCta && buyBlock && bottomCta && 'IntersectionObserver' in window) {
      var state = { buyPassed: false, bottomVisible: false };

      function applyState() {
        if (state.buyPassed && !state.bottomVisible) {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      }

      var buyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            state.buyPassed = true;
          } else if (entry.isIntersecting) {
            state.buyPassed = false;
          }
          applyState();
        });
      }, { threshold: 0 });
      buyObs.observe(buyBlock);

      var bottomObs = new IntersectionObserver(function(entries) {
        state.bottomVisible = entries[0].isIntersecting;
        applyState();
      }, { threshold: 0.05 });
      bottomObs.observe(bottomCta);
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storm-600"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* === Hero — random slide on page load === */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var captions = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          captions.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

    /* === Reveal on scroll === */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* === Gallery thumbnails === */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullUrl = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl) {
            mainImg.src = fullUrl;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* === Cart forms (main, bottom, sticky — single handler) === */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

    /* === FAQ accordion ===
       Handled by the inline script at the end of the section markup. */

    /* === Sticky mobile CTA visibility === */
    var stickyCta = section.querySelector('[data-sl-sticky-cta]');
    var buyBlock = section.querySelector('.sl-buy-block');
    var bottomCta = section.querySelector('.sl-bottom-cta');

    if (stickyCta && buyBlock && bottomCta && 'IntersectionObserver' in window) {
      var state = { buyPassed: false, bottomVisible: false };

      function applyState() {
        if (state.buyPassed && !state.bottomVisible) {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      }

      var buyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            state.buyPassed = true;
          } else if (entry.isIntersecting) {
            state.buyPassed = false;
          }
          applyState();
        });
      }, { threshold: 0 });
      buyObs.observe(buyBlock);

      var bottomObs = new IntersectionObserver(function(entries) {
        state.bottomVisible = entries[0].isIntersecting;
        applyState();
      }, { threshold: 0.05 });
      bottomObs.observe(bottomCta);
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storm-8500"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.stormlight-product-section');
  if (!sections.length) return;

  sections.forEach(function(section) {

    /* === Hero — random slide on page load === */
    var heroRandom = section.querySelector('[data-sl-hero-random]');
    if (heroRandom) {
      var slideCount = parseInt(heroRandom.getAttribute('data-slide-count'), 10) || 0;
      if (slideCount > 1) {
        var pick = Math.floor(Math.random() * slideCount);
        if (pick !== 0) {
          var slides = heroRandom.querySelectorAll('.sl-hero-slide');
          var captions = section.querySelectorAll('.sl-hero-credit-slide');
          slides.forEach(function(s, i) {
            s.classList.toggle('is-active', i === pick);
          });
          captions.forEach(function(c, i) {
            c.classList.toggle('is-active', i === pick);
          });
        }
      }
    }

    /* === Reveal on scroll === */
    var revealEls = section.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el) { io.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    /* === Gallery thumbnails === */
    var mainImg = section.querySelector('#sl-gallery-active');
    var thumbs = section.querySelectorAll('.sl-gallery-thumb');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullUrl = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (fullUrl) {
            mainImg.src = fullUrl;
            if (srcset) mainImg.srcset = srcset;
            if (alt) mainImg.alt = alt;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }

    /* === Cart forms (main, bottom, sticky — single handler) === */
    var forms = section.querySelectorAll('[data-sl-cart-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.sl-add-to-cart');
        var feedback = form.querySelector('[data-sl-cart-feedback]');
        if (!btn || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        if (feedback) {
          feedback.textContent = '';
          feedback.classList.remove('is-error');
        }

        var formData = new FormData(form);
        fetch(form.action + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(data) {
          if (feedback) feedback.textContent = 'Added to cart';
          return fetch(section.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response) {
          if (response && response.ok) return response.json();
          return null;
        })
        .then(function(cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function() {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function(err) {
          if (feedback) {
            feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart';
            feedback.classList.add('is-error');
          }
        })
        .finally(function() {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });

    /* === FAQ accordion ===
       Handled by the inline script at the end of the section markup. */

    /* === Sticky mobile CTA visibility === */
    var stickyCta = section.querySelector('[data-sl-sticky-cta]');
    var buyBlock = section.querySelector('.sl-buy-block');
    var bottomCta = section.querySelector('.sl-bottom-cta');

    if (stickyCta && buyBlock && bottomCta && 'IntersectionObserver' in window) {
      var state = { buyPassed: false, bottomVisible: false };

      function applyState() {
        if (state.buyPassed && !state.bottomVisible) {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      }

      var buyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            state.buyPassed = true;
          } else if (entry.isIntersecting) {
            state.buyPassed = false;
          }
          applyState();
        });
      }, { threshold: 0 });
      buyObs.observe(buyBlock);

      var bottomObs = new IntersectionObserver(function(entries) {
        state.bottomVisible = entries[0].isIntersecting;
        applyState();
      }, { threshold: 0.05 });
      bottomObs.observe(bottomCta);
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.stormlight-warranty-section[data-section-id]');
    if (!section) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = section.querySelectorAll('.reveal');

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function(el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function(el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
